import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";
import Select from "react-select";
import {cloneDeep} from "lodash";
import {monthOptions, yearOptions} from "@app/utils/CommonUtils";
import {Provinces} from "@app/constants/Provinces";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {requestGetEmployerList} from "@app/services/EmployerService";
import CareerSummaryRefCheckListModal from "@pages/candidate/detail/CareerSummaryRefCheckListModal";

const CareerSummaries = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showCareerSummaryRefCheckListModal, setShowCareerSummaryRefCheckListModal] = useState(false);
    const [isEditCareerSummary, setIsEditCareerSummary] = useState(false);
    const [careerSummaries, setCareerSummaries] = useState([]);
    const [notes, setNotes] = useState([]);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [workYears, setWorkYears] = useState([]);
    const [workMonths, setWorkMonths] = useState([]);
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [employerOptions, setEmployerOptions] = useState([]);
    const [selectCareerSummaryId, setSelectCareerSummaryId] = useState('');

    const {candidateId} = props

    const fetchCandidateCareerSummary = (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateCareerDetail(canId).then((res) => {
            console.log(JSON.stringify(res))
            setCareerSummaries(cloneDeep(res.content))
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const fetchEmployees = () => {
        setIsLoading(true)

        requestGetEmployerList({}). then((res) => {
            const allEmployees = res.content.employers;
            const empOptionList = []
            allEmployees.forEach((item, index) => {
                empOptionList.push({value: item.id, label: item.name})
            });
            empOptionList.push({value: 'create_new_emp', label: ' + Tạo mới'})
            setEmployerOptions(empOptionList);
        }).catch((error) => {
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const openCreateEmployerTab = (careerItem) => {
        window.open(`/employer/add?employer_name=${careerItem.origin_company}`, '_blank').focus();
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }

        setWorkMonths(monthOptions())
        setWorkYears(yearOptions())
        if (provinceOptions.length === 0) {
            let provinces = [];
            Provinces.forEach(item => {
                provinces.push({
                    value: item,
                    label: item.charAt(0).toUpperCase() + item.slice(1)
                });
            });
            setProvinceOptions(provinces);
        }

        fetchEmployees();
    }, [])

    useEffect(() => {
        fetchCandidateCareerSummary(candidateId)
    }, [candidateId])

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                // Người dùng rời khỏi tab này hoặc mở tab mới.
            } else if (document.visibilityState === "visible") {
                // Người dùng quay lại tab này.
                fetchEmployees()
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Dọn dẹp khi component bị unmount
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    const onAddCareerSummary = (event) => {
        console.log('onAddCareerSummary');

        if (careerSummaries.length > 0) {
            let latestRow = careerSummaries[careerSummaries.length-1]
            let rowIsBlank = true
            Object.keys(latestRow).forEach(key => {
                if (key !== 'displayed_flag' && latestRow[key] && key !== 'created_user' && latestRow[key]) {
                    rowIsBlank = false
                }
            })

            if (rowIsBlank) {
                alert("Tồn tại record career summary chưa được nhập thông tin.")
                return;
            }
        }


        careerSummaries.push({
            work_start_year: '',
            work_start_month: '',
            work_end_year: '',
            work_end_month: '',
            origin_company: '',
            title: '',
            company_note: '',
            note_of_period: '',
            displayed_flag: careerSummaries.length === 0,
            created_user: userLoginInfo.id
        });

        setCareerSummaries([...careerSummaries]);
    };
    const onSortCareerSummary = () => {
        careerSummaries.sort(function(a, b) {
            if (a.work_start_year.value < b.work_start_year.value) {
                return 1;
            }
            if (a.work_start_year.value > b.work_start_year.value) {
                return -1;
            }

            if (a.work_start_month.value < b.work_start_month.value) {
                return 1;
            }
            if (a.work_start_month.value > b.work_start_month.value) {
                return -1;
            }
            return 0;
        });

        setCareerSummaries([...careerSummaries]);
    };
    const onDeleteCareerSummary = (index) => {
        if (careerSummaries.length === 1) {
            setCareerSummaries([]);
        } else {
            careerSummaries.splice(index, 1);
            setCareerSummaries([...careerSummaries]);
        }
    };
    const onShowRefCheck = (careerSumId) => {
        setSelectCareerSummaryId(careerSumId);
        setShowCareerSummaryRefCheckListModal(true);
    };
    const onChangeCareerInput = (event, index) => {
        console.log('onChangeCareerInput');
        let fieldName = event.target.name
        if (fieldName === 'displayed_flag') {
            careerSummaries.map(item => {
                item.displayed_flag = false
                return item;
            })
            careerSummaries[index]["displayed_flag"] = true
        } else {
            careerSummaries[index][fieldName] = event.target.value;
        }

        setCareerSummaries([...careerSummaries]);
    };

    const onChangeEmployerInput = (event, index) => {
        console.log('onChangeEmployerInput');
        if (event.value === 'create_new_emp') {
            openCreateEmployerTab(careerSummaries[index]);
            return;
        }
        careerSummaries[index]["employer"] = event
        careerSummaries[index]["employer_id"] = event.value
        setCareerSummaries([...careerSummaries]);
    };

    const onChangeWorkTime = (index, value, fieldName) => {
        console.log('onChangeWorkTime');
        // Validate require end time >= start time
        let currentRow = careerSummaries[index];
        let oldValue = currentRow[fieldName];
        //set new value temp
        currentRow[fieldName] = value;
        if (currentRow.work_start_year.value && currentRow.work_end_year.value && currentRow.work_start_year.value > currentRow.work_end_year.value
            || (currentRow.work_start_year.value === currentRow.work_end_year.value
                && currentRow.work_start_month.value > currentRow.work_end_month.value)) {
            currentRow[fieldName] = oldValue;
            alert('Time kết thúc phải sau Time bắt đầu.');
            return;
        }

        if (fieldName === 'work_end_year' || fieldName === 'work_end_month') {
            // Auto set work status is off, if work end year month is none blank.
            if ((currentRow.work_end_year && currentRow.work_end_year.value) || (currentRow.work_end_month && currentRow.work_end_month.value)) {
                currentRow['work_status'] = '2' // off;
            }
        }

        setCareerSummaries([...careerSummaries]);
    };

    const onRemoveSpace = (fieldName, careerIndex) => {
        if (['origin_company', 'title'].includes(fieldName)) {
            // Trường hợp là các field trong career summaries
            if (careerIndex !== undefined && careerIndex !== "") {
                let fieldValue = careerSummaries[careerIndex][fieldName]
                if (fieldValue) {
                    fieldValue = fieldValue.replaceAll(" ", "")
                    careerSummaries[careerIndex][fieldName] = fieldValue;
                    setCareerSummaries([...careerSummaries]);
                }

            }
        }
    };

    const updateCandidateCareerSummary = () => {
        setIsLoading(true)
        CandidateService.updateCandidateCareerDetail({candidate_id: candidateId, career_summaries: careerSummaries}).then((res) => {
            showSuccessMessageSaveData(res.sts_code)
            setIsEditCareerSummary(false)
            fetchCandidateCareerSummary(candidateId)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const disableWorkStatus = (item) => {
        if (!isEditCareerSummary || userLoginInfo.id !== item.created_user) {
            return true
        }

        return ((item.work_end_year && item.work_end_year.value) || (item.work_end_month && item.work_end_month.value));
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Danh sách career summary</h3>
                    <div className={'card-tools'}>
                        {!isEditCareerSummary &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEditCareerSummary(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                        {isEditCareerSummary &&
                            <button className='btn btn-default mr-3' type={'button'}
                                    onClick={() => setIsEditCareerSummary(false)}>
                                Cancel
                            </button>}
                        {isEditCareerSummary &&
                            <button className='btn btn-info mr-3' type={'button'}
                                    onClick={() => updateCandidateCareerSummary()}>
                                <i className='fas fa-save'/> Save
                            </button>}
                        {isEditCareerSummary &&
                            <button className='btn btn-warning mr-3' type={'button'}
                                    onClick={() => onSortCareerSummary()}>
                                <i className='fas fa-sync'/> Sắp xếp
                            </button>}
                        {isEditCareerSummary &&
                            <button className='btn btn-primary mr-3' type={'button'}
                                    onClick={() => onAddCareerSummary()}>
                                <i className='fas fa-plus'/> Thêm
                            </button>}
                    </div>
                </div>
                <div className='card-body table-responsive p-0 w-100'
                     style={{height: '65vh', overflow: 'auto'}}>
                    <table
                        className='table table-hover table-bordered text-nowrap'
                        style={{
                            maxHeight: '80vh',
                            overflow: 'scroll',
                            minHeight: 300
                        }}
                    >
                        <thead>
                        <tr>
                            <th>STT</th>
                            <th>Time bắt đầu&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Time kết thúc&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Time có làm&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Company (TT
                                gốc)&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Title &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Email Công
                                ty  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Số ĐT Công
                                ty &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Working status</th>
                            <th>Note
                                company&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Company
                                location&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Company
                                industry&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Note of
                                period&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                            <th>Employer&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; </th>
                            <th>Displayed period</th>
                            <th>Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        {careerSummaries && careerSummaries.length > 0
                            && careerSummaries.map((item, index) => (
                                <tr key={`career_summary_${index}`}>
                                    <td className={userLoginInfo.id !== item.created_user ? "bg-success" : ""}
                                        title={`Người input: ${item.user_input}; Ngày NL mới nhất: ${item.updated_date_time}`}>
                                        {index + 1}
                                    </td>
                                    <td>
                                        <div className={'row'}>
                                            <div className={'col-sm-12'}>
                                                <Select options={workYears}
                                                        isDisabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                        placeholder={'Năm'}
                                                        value={item.work_start_year ? item.work_start_year : ''}
                                                        onChange={value => {
                                                            onChangeWorkTime(index, value, 'work_start_year');
                                                        }}
                                                />
                                            </div>
                                            <div className={'col-sm-12 mt-1'}>
                                                <Select options={workMonths}
                                                        isDisabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                        placeholder={'Tháng'}
                                                        value={item.work_start_month ? item.work_start_month : ''}
                                                        onChange={value => {
                                                            onChangeWorkTime(index, value, 'work_start_month');
                                                        }}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={'row'}>
                                            <div className={'col-sm-12'}>
                                                <Select options={workYears}
                                                        isDisabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                        placeholder={'Năm'}
                                                        value={item.work_end_year ? item.work_end_year : ''}
                                                        onChange={value => {
                                                            onChangeWorkTime(index, value, 'work_end_year');
                                                        }}
                                                />
                                            </div>
                                            <div className={'col-sm-12 mt-1'}>
                                                <Select options={workMonths}
                                                        isDisabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                        placeholder={'Tháng'}
                                                        value={item.work_end_month ? item.work_end_month : ''}
                                                        onChange={value => {
                                                            onChangeWorkTime(index, value, 'work_end_month');
                                                        }}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={'row'}>
                                            <div className={'col-sm-12'}>
                                                <Select options={workYears}
                                                        isDisabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                        placeholder={'Năm'}
                                                        value={item.work_year ? item.work_year : ''}
                                                        onChange={value => {
                                                            onChangeWorkTime(index, value, 'work_year');
                                                        }}
                                                />
                                            </div>
                                            <div className={'col-sm-12 mt-1'}>
                                                <Select options={workMonths}
                                                        isDisabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                        placeholder={'Tháng'}
                                                        value={item.work_month ? item.work_month : ''}
                                                        onChange={value => {
                                                            onChangeWorkTime(index, value, 'work_month');
                                                        }}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                <textarea className='form-control'
                                          disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                          value={item.origin_company ? item.origin_company : ''}
                                          name={'origin_company'}
                                          onChange={event => onChangeCareerInput(event, index)}/>
                                        <div className={'col-sm-12'}>
                                    <span className={'input-group-append mt-2'}>
                                        <button type='button'
                                                className='btn btn-warning btn-flat btn-sm'
                                                disabled={userLoginInfo.id !== item.created_user}
                                                onClick={() => onRemoveSpace('origin_company', index)}>
                                            Xóa blanks
                                        </button>
                                    </span>
                                        </div>
                                    </td>
                                    <td>
                                        <input type='text' className='form-control'
                                               value={item.title ? item.title : ''}
                                               disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                               name={'title'}
                                               onChange={event => onChangeCareerInput(event, index)}/>
                                        <div className={'col-sm-12'}>
                                    <span className={'input-group-append mt-2'}>
                                        <button type='button'
                                                className='btn btn-warning btn-flat btn-sm'
                                                disabled={userLoginInfo.id !== item.created_user}
                                                onClick={() => onRemoveSpace('title', index)}>
                                            Xóa blanks
                                        </button>
                                    </span>
                                        </div>
                                    </td>
                                    <td>
                                        <input type='text' className='form-control'
                                               value={item.company_email ? item.company_email : ''}
                                               disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                               name={'company_email'}
                                               onChange={event => onChangeCareerInput(event, index)}/>
                                    </td>
                                    <td>
                                        <input type='text' className='form-control'
                                               value={item.company_phone ? item.company_phone : ''}
                                               disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                               name={'company_phone'}
                                               onChange={event => onChangeCareerInput(event, index)}/>
                                    </td>
                                    <td>
                                        <select className='form-control'
                                                name={'work_status'}
                                                disabled={disableWorkStatus(item)}
                                                value={item.work_status ? item.work_status.toString() : '0'}
                                                onChange={event => onChangeCareerInput(event, index)}>
                                            <option value='0'>N/A</option>
                                            <option value='1'>On</option>
                                            <option value='2'>Off</option>
                                        </select>
                                    </td>
                                    <td>
                                <textarea className='form-control'
                                          disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                          value={item.company_note ? item.company_note : ''}
                                          name={'company_note'}
                                          onChange={event => onChangeCareerInput(event, index)}/>
                                    </td>
                                    <td>
                                        <input className='form-control'
                                               disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                               type={"text"}
                                               value={item.company_provionce_note ? item.company_province_note : ''}
                                               name={'company_province_note'}
                                               onChange={event => onChangeCareerInput(event, index)}/>
                                    </td>
                                    <td>
                                        <input className='form-control'
                                               disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                               type={"text"}
                                               value={item.company_industry_note ? item.company_industry_note : ''}
                                               name={'company_industry_note'}
                                               onChange={event => onChangeCareerInput(event, index)}/>
                                    </td>
                                    <td>
                                <textarea className='form-control'
                                          disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                          value={item.note_of_period ? item.note_of_period : ''}
                                          name={'note_of_period'}
                                          onChange={event => onChangeCareerInput(event, index)}/>
                                    </td>
                                    <td>
                                        {(!isEditCareerSummary || userLoginInfo.id !== item.created_user) ?
                                            <a href={`/employer/edit/${item.employer?.value}`}>{item.employer?.label}</a>
                                            :
                                            <Select options={employerOptions}
                                                    isDisabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                    placeholder={"Chọn employer"}
                                                    value={item.employer}
                                                    name={"employer"}
                                                    onChange={values => {
                                                        onChangeEmployerInput(values, index);
                                                    }}
                                            />
                                        }
                                    </td>
                                    <td>
                                        <div className='checkbox'>
                                            <input className='form-control'
                                                   disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                   type={'radio'}
                                                   value={item.displayed_flag}
                                                   checked={item.displayed_flag}
                                                   name={`displayed_flag`}
                                                   onChange={event => onChangeCareerInput(event, index)}/>
                                        </div>
                                    </td>
                                    <td>
                                        <button className='btn btn-danger' type={'button'}
                                                disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                onClick={() => onDeleteCareerSummary(index)}>
                                            Xóa
                                        </button>
                                        {item.id &&
                                        <button className='btn btn-default ml-1' type={'button'}
                                                disabled={!isEditCareerSummary || userLoginInfo.id !== item.created_user}
                                                onClick={() => onShowRefCheck(item.id)}>
                                            Ref check
                                        </button>
                                        }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {showCareerSummaryRefCheckListModal &&
            <CareerSummaryRefCheckListModal
                careerSummaryId={selectCareerSummaryId}
                isShow={showCareerSummaryRefCheckListModal}
                onClose={() => setShowCareerSummaryRefCheckListModal(false)}
            />
            }
        </>
    )
}

export default CareerSummaries;
